import styled from "styled-components";

export const AlertWrapper = styled.div`
  background-color: #fff7e6;
  border: 1px solid #ffd591;
  padding: 12px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
`;

export const AlertText = styled.span`
  color: #874d00;
  font-size: 14px;
`;

export const TableContainer = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
`;

export const TableHeader = styled.div`
  display: flex;
  background-color: #fafafa;
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  font-weight: bold;
  color: #595959;
  font-size: 12px;
`;

export const TableRow = styled.div`
  display: flex;
  flex-direction: row; 
  padding: 12px;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
`;

export const Col = styled.div<{ flex: number; center?: boolean }>`
  flex: ${(props) => props.flex};
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: ${(props) => (props.center ? "center" : "left")};
  
  svg {
    margin-right: 4px;
    color: #bfbfbf;
  }
`;

export const TableBody = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 400px; 
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #e8e8e8;
    border-radius: 10px;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;
`;

export const ActionIconWrapper = styled.div<{ $disabled: boolean; $activeColor: string }>`
  display: flex;
  align-items: center;
  color: ${(props) => (props.$disabled ? "#bfbfbf" : props.$activeColor)};
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  transition: transform 0.2s;

  &:hover {
    transform: ${(props) => (props.$disabled ? "none" : "scale(1.1)")};
  }
`;

export const ProtocolNumber = styled.span`
  color: #1890ff;
  font-weight: bold;
  font-size: 14px;
`;

export const ProtocolDesc = styled.span`
  color: #595959;
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
`;

export const TextData = styled.span`
  color: #595959;
  font-size: 13px;
`;

export const FooterWrapper = styled.div`
  margin-top: 24px;
  
  .btn-create-global {
    width: 100%;
    background-color: #d4380d;
    border-color: #d4380d;
    color: white;
    height: 40px;
    font-weight: bold;

    &:hover {
      background-color: #f5222d;
    }
 } 
`;
